// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"preview_wrapper__Yf8hn","container":"preview_container__D8fh9","video":"preview_video__A1Gbj","play":"preview_play__bUsrk"};